import { render, staticRenderFns } from "./telInfo.vue?vue&type=template&id=5bfae82e&scoped=true&"
import script from "./telInfo.vue?vue&type=script&lang=js&"
export * from "./telInfo.vue?vue&type=script&lang=js&"
import style0 from "./telInfo.vue?vue&type=style&index=0&id=5bfae82e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfae82e",
  null
  
)

export default component.exports